(ns ui.editor2.sidebar-panel-ai)

(defn ai-icon [selected?]
  [:svg.size-6
   {:xmlns "http://www.w3.org/2000/svg"
    :fill "none"
    :viewBox "0 0 24 24"
    :stroke-width "1.5"
    :stroke "currentColor"
    :class ["size-6" (when-not selected? "text-slate-400")]}
   [:path
    {:stroke-linecap "round"
     :stroke-linejoin "round"
     :d "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"}]])

(defn ai-entry
  [selected?]
  [:div
   {:class ["flex" "pt-3" "pb-3" "pl-2" "pr-2" "flex-col" "justify-center" "items-center" "gap-1" "rounded-lg" "cursor-pointer" "hover:bg-gray-600"
            (when selected?
              "bg-gray-800")]
    :on {:click [[:store/assoc-in [:editor2 :sidebar-panel] :ai]]}}
   (ai-icon selected?)
   [:span
    {:class ["text-center" "text-xs" "font-medium" "font-medium" (when-not selected? "text-slate-400")]}
    "AI"]])

(defn panel
  [state]
  [:div
   {:class ["flex" "flex-col" "gap-2" "w-full"]}
   ;; panel-grid-list__content

   [:div.pb-5
    [:h3.text-base.font-semibold.text-white-900.flex.items-center.gap-2
     "FREE Subtitle Generator"
     [:span
      {:class ["px-1.5" "py-0.5" "text-[9px]" "font-bold" "leading-none" "text-white" "bg-red-500" "rounded-full" "uppercase" "tracking-wide"]}
      "NEW"]]
    [:div.mt-2.max-w-xl.text-sm.text-white-500
     [:p
      "Auto-generate per-word transcripts and burn animated captions
       with active-word highlights directly into your video — all with
       our free online tool."]
     [:div.grid.grid-cols-2.md:grid-cols-2.gap-4.mt-5
      [:div
       [:video.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/subtitle_generator_1.mp4"
         :autoplay true
         :loop true
         :muted true
         :playsinline true
         :replicant/on-mount (fn [{:keys [replicant/node]}]
                               (set! (.-muted node) true))}]]
      [:div
       [:video.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/subtitle_generator_2.mp4"
         :autoplay true
         :loop true
         :muted true
         :playsinline true
         :replicant/on-mount (fn [{:keys [replicant/node]}]
                               (set! (.-muted node) true))}]]]]
    [:div.mt-5
     [:a.w-full.flex.items-center.justify-center.bg-gray-500.rounded-md.p-2.text-white.no-underline
      {:href "https://www.storrito.com/tools/subtitle-generator/"
       :target "_blank"
       :rel "noopener"
       :on {:click [[:editor2/track-promotion-click
                     {:category "promotion"
                      :action "click"
                      :name "subtitle-generator"}]]}}
      [:svg
       {:xmlns "http://www.w3.org/2000/svg"
        :viewBox "0 0 24 24"
        :fill "currentColor"
        :width "20"
        :height "20"}
       [:path
        {:d "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"}]]
      [:span.hidden.lg:block.ml-2
       "Open free tool"]]]]

   [:div.separator.bg-gray-500
    {:style {:width "100%"
             :height 0
             :border-top "1px solid #ededed"
             :margin-top "10px"
             :margin-bottom "10px"}}]

   [:div.pb-5
    [:h3.text-base.font-semibold.text-white-900
     "Image Generation"]
    [:div.mt-2.max-w-xl.text-sm.text-white-500
     [:p
      "Blackforest is an advanced AI tool that turns your words into unique most realistic images. NSFW content is not supported."]
     [:div.grid.grid-cols-2.md:grid-cols-2.gap-4.mt-5
      [:div
       [:img.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/blackforest_1.jpeg"
         :alt ""}]]
      [:div
       [:img.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/blackforest_2.jpeg"
         :alt ""}]]]]
    [:div.mt-5
     [:button.w-full.flex.items-center.justify-center.bg-gray-500.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/image-generation-modal-blackforest
                     {:source :editor2}                         ;; params map
                     ]]}}
      [:svg
       {:fill "currentColor"
        :fill-rule "evenodd"
        :height "24px"
        :viewBox "0 0 24 24"
        :width "24px"
        :xmlns "http://www.w3.org/2000/svg"}
       [:path {:d "M0 20.683L12.01 2.5 24 20.683h-2.233L12.009 5.878 3.471 18.806h12.122l1.239 1.877H0z"}]
       [:path {:d "M8.069 16.724l2.073-3.115 2.074 3.115H8.069zM18.24 20.683l-5.668-8.707h2.177l5.686 8.707h-2.196zM19.74 11.676l2.13-3.19 2.13 3.19h-4.26z"}]]
      [:span.hidden.lg:block.ml-2
       "Blackforest"]]]]

   [:div.separator.bg-gray-500
    {:style {:width "100%"
             :height 0
             :border-top "1px solid #ededed"
             :margin-top "10px"
             :margin-bottom "10px"}}]

   [:div.pb-5
    [:h3.text-base.font-semibold.text-white-900
     "Image Generation"]
    [:div.mt-2.max-w-xl.text-sm.text-white-500
     [:p
      "DALL·E is an advanced AI tool that turns your words into unique hyper-real and dramatic images. NSFW content is not supported."]
     [:div.grid.grid-cols-2.md:grid-cols-2.gap-4.mt-5
      [:div
       [:img.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/dalle_1.jpeg"
         :alt ""}]]
      [:div
       [:img.h-auto.max-w-full.rounded-lg
        {:src "/img/ai/dalle_2.jpeg"
         :alt ""}]]]]
    [:div.mt-5
     [:button.w-full.flex.items-center.justify-center.bg-gray-500.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/openai-image-generation-modal
                     {:source :editor2}                        ;; params map
                     ]]}}
      [:svg
       {:height "16"
        :viewBox "-1 -.1 949.1 959.8"
        :width "16"
        :fill "currentColor"
        :xmlns "http://www.w3.org/2000/svg"}
       [:path {:d "m925.8 456.3c10.4 23.2 17 48 19.7 73.3 2.6 25.3 1.3 50.9-4.1 75.8-5.3 24.9-14.5 48.8-27.3 70.8-8.4 14.7-18.3 28.5-29.7 41.2-11.3 12.6-23.9 24-37.6 34-13.8 10-28.5 18.4-44.1 25.3-15.5 6.8-31.7 12-48.3 15.4-7.8 24.2-19.4 47.1-34.4 67.7-14.9 20.6-33 38.7-53.6 53.6-20.6 15-43.4 26.6-67.6 34.4-24.2 7.9-49.5 11.8-75 11.8-16.9.1-33.9-1.7-50.5-5.1-16.5-3.5-32.7-8.8-48.2-15.7s-30.2-15.5-43.9-25.5c-13.6-10-26.2-21.5-37.4-34.2-25 5.4-50.6 6.7-75.9 4.1-25.3-2.7-50.1-9.3-73.4-19.7-23.2-10.3-44.7-24.3-63.6-41.4s-35-37.1-47.7-59.1c-8.5-14.7-15.5-30.2-20.8-46.3s-8.8-32.7-10.6-49.6c-1.8-16.8-1.7-33.8.1-50.7 1.8-16.8 5.5-33.4 10.8-49.5-17-18.9-31-40.4-41.4-63.6-10.3-23.3-17-48-19.6-73.3-2.7-25.3-1.3-50.9 4-75.8s14.5-48.8 27.3-70.8c8.4-14.7 18.3-28.6 29.6-41.2s24-24 37.7-34 28.5-18.5 44-25.3c15.6-6.9 31.8-12 48.4-15.4 7.8-24.3 19.4-47.1 34.3-67.7 15-20.6 33.1-38.7 53.7-53.7 20.6-14.9 43.4-26.5 67.6-34.4 24.2-7.8 49.5-11.8 75-11.7 16.9-.1 33.9 1.6 50.5 5.1s32.8 8.7 48.3 15.6c15.5 7 30.2 15.5 43.9 25.5 13.7 10.1 26.3 21.5 37.5 34.2 24.9-5.3 50.5-6.6 75.8-4s50 9.3 73.3 19.6c23.2 10.4 44.7 24.3 63.6 41.4 18.9 17 35 36.9 47.7 59 8.5 14.6 15.5 30.1 20.8 46.3 5.3 16.1 8.9 32.7 10.6 49.6 1.8 16.9 1.8 33.9-.1 50.8-1.8 16.9-5.5 33.5-10.8 49.6 17.1 18.9 31 40.3 41.4 63.6zm-333.2 426.9c21.8-9 41.6-22.3 58.3-39s30-36.5 39-58.4c9-21.8 13.7-45.2 13.7-68.8v-223q-.1-.3-.2-.7-.1-.3-.3-.6-.2-.3-.5-.5-.3-.3-.6-.4l-80.7-46.6v269.4c0 2.7-.4 5.5-1.1 8.1-.7 2.7-1.7 5.2-3.1 7.6s-3 4.6-5 6.5a32.1 32.1 0 0 1 -6.5 5l-191.1 110.3c-1.6 1-4.3 2.4-5.7 3.2 7.9 6.7 16.5 12.6 25.5 17.8 9.1 5.2 18.5 9.6 28.3 13.2 9.8 3.5 19.9 6.2 30.1 8 10.3 1.8 20.7 2.7 31.1 2.7 23.6 0 47-4.7 68.8-13.8zm-455.1-151.4c11.9 20.5 27.6 38.3 46.3 52.7 18.8 14.4 40.1 24.9 62.9 31s46.6 7.7 70 4.6 45.9-10.7 66.4-22.5l193.2-111.5.5-.5q.2-.2.3-.6.2-.3.3-.6v-94l-233.2 134.9c-2.4 1.4-4.9 2.4-7.5 3.2-2.7.7-5.4 1-8.2 1-2.7 0-5.4-.3-8.1-1-2.6-.8-5.2-1.8-7.6-3.2l-191.1-110.4c-1.7-1-4.2-2.5-5.6-3.4-1.8 10.3-2.7 20.7-2.7 31.1s1 20.8 2.8 31.1c1.8 10.2 4.6 20.3 8.1 30.1 3.6 9.8 8 19.2 13.2 28.2zm-50.2-417c-11.8 20.5-19.4 43.1-22.5 66.5s-1.5 47.1 4.6 70c6.1 22.8 16.6 44.1 31 62.9 14.4 18.7 32.3 34.4 52.7 46.2l193.1 111.6q.3.1.7.2h.7q.4 0 .7-.2.3-.1.6-.3l81-46.8-233.2-134.6c-2.3-1.4-4.5-3.1-6.5-5a32.1 32.1 0 0 1 -5-6.5c-1.3-2.4-2.4-4.9-3.1-7.6-.7-2.6-1.1-5.3-1-8.1v-227.1c-9.8 3.6-19.3 8-28.3 13.2-9 5.3-17.5 11.3-25.5 18-7.9 6.7-15.3 14.1-22 22.1-6.7 7.9-12.6 16.5-17.8 25.5zm663.3 154.4c2.4 1.4 4.6 3 6.6 5 1.9 1.9 3.6 4.1 5 6.5 1.3 2.4 2.4 5 3.1 7.6.6 2.7 1 5.4.9 8.2v227.1c32.1-11.8 60.1-32.5 80.8-59.7 20.8-27.2 33.3-59.7 36.2-93.7s-3.9-68.2-19.7-98.5-39.9-55.5-69.5-72.5l-193.1-111.6q-.3-.1-.7-.2h-.7q-.3.1-.7.2-.3.1-.6.3l-80.6 46.6 233.2 134.7zm80.5-121h-.1v.1zm-.1-.1c5.8-33.6 1.9-68.2-11.3-99.7-13.1-31.5-35-58.6-63-78.2-28-19.5-61-30.7-95.1-32.2-34.2-1.4-68 6.9-97.6 23.9l-193.1 111.5q-.3.2-.5.5l-.4.6q-.1.3-.2.7-.1.3-.1.7v93.2l233.2-134.7c2.4-1.4 5-2.4 7.6-3.2 2.7-.7 5.4-1 8.1-1 2.8 0 5.5.3 8.2 1 2.6.8 5.1 1.8 7.5 3.2l191.1 110.4c1.7 1 4.2 2.4 5.6 3.3zm-505.3-103.2c0-2.7.4-5.4 1.1-8.1.7-2.6 1.7-5.2 3.1-7.6 1.4-2.3 3-4.5 5-6.5 1.9-1.9 4.1-3.6 6.5-4.9l191.1-110.3c1.8-1.1 4.3-2.5 5.7-3.2-26.2-21.9-58.2-35.9-92.1-40.2-33.9-4.4-68.3 1-99.2 15.5-31 14.5-57.2 37.6-75.5 66.4-18.3 28.9-28 62.3-28 96.5v223q.1.4.2.7.1.3.3.6.2.3.5.6.2.2.6.4l80.7 46.6zm43.8 294.7 103.9 60 103.9-60v-119.9l-103.8-60-103.9 60z"}]]
      [:span.hidden.lg:block.ml-2
       "Dall-E"]]]]])